import { io } from "socket.io-client";

const customParser = require("socket.io-msgpack-parser");
//Namespaces
export const prematchNamespace = "pre-match";
export const livematchNamespace = "live-match";
//Events
export const dashboardPreMatchEvent =
  "/" + prematchNamespace + "/preMatChangeUpdate/dashboard";
export const dashboardLiveMatchEvent =
  "/" + livematchNamespace + "/changeStatus/dashboard";

export const topDashboardPreMatchEvent =
  "/" + prematchNamespace + "/preMatChangeUpdate/top";
export const topDashboardLiveMatchEvent =
  "/" + livematchNamespace + "/changeStatus/top";

export const preMatchSingleEvent =
  "/" + prematchNamespace + "/preMatChangeUpdate";
export const liveMatchSingleEvent = "/" + livematchNamespace + "/changeStatus";

export const betslipPreMatchEvent =
  "/" + prematchNamespace + "/preMatChangeUpdate/betslip";
export const betslipLiveMatchEvent =
  "/" + livematchNamespace + "/changeStatus/betslip";

export const sponserPreMatchEvent =
  "/" + prematchNamespace + "/preMatChangeUpdate/sponsored";
export const sponserLiveMatchEvent =
  "/" + livematchNamespace + "/changeStatus/sponsored";
export const sponserBetslipPreMatchEvent =
  "/" + prematchNamespace + "/preMatChangeUpdate/betslipSponsored";
export const sponserBetslipLiveMatchEvent =
  "/" + livematchNamespace + "/changeStatus/betslipSponsored";

//socket instances
export const preLiveSocket = io(
  `${process.env.REACT_APP_SPORTSBOOK_NODE_WS_URL}/${prematchNamespace}`,
  {
    forceNew: true,
    transports: ["websocket"],
    parser: customParser
  }
);

export const liveSocket = io(
  `${process.env.REACT_APP_SPORTSBOOK_NODE_WS_URL}/${livematchNamespace}`,
  {
    forceNew: true,
    transports: ["websocket"],
    parser: customParser
  }
);
